






















































import { mapActions } from 'vuex';
import { Component, Vue, Watch } from 'vue-property-decorator';
import '@/types';
import cCard from '@/components/default/Card.vue';

import notificationService from '@/services/notificationService';
import Subcontractor from '@/classes/CRM/Subcontractor';
import CompanyDetailsCard from '@/components/crm/company/CompanyDetailsCard.vue';
import SubcontractorTeamsCard from '@/components/crm/subcontractor/SubcontractorTeamsCard.vue';
import CompanyEmployeeCard from '@/components/crm/company/CompanyEmployeesCard.vue';
import SubcontractorLabourAgreementCard from '@/components/crm/subcontractor/SubcontractorLabourAgreementCard.vue';
import SubcontractorAverageRatingCard from '@/components/crm/subcontractor/SubcontractorAverageRatingCard.vue';
import ContactPricingAgreementCard from '@/components/crm/shared/ContactPricingAgreementCard.vue';
import projectOverviewCard from '@/components/projects/projectsOverviewCard.vue';
import FilesCard from '@/components/varia/FilesCard.vue';

@Component({
  components: {
    cCard,
    CompanyDetailsCard,
    SubcontractorTeamsCard,
    CompanyEmployeeCard,
    SubcontractorLabourAgreementCard,
    ContactPricingAgreementCard,
    projectOverviewCard,
    FilesCard,
    SubcontractorAverageRatingCard
  },
})
export default class SubcontractorDetails extends Vue {
  public subcontractor: Subcontractor = new Subcontractor();
  public initialising: boolean = true;

  public async addOrUpdateAddress(address: IAddress, index: number) {
    const success = await this.subcontractor.addOrUpdateAddress(address, index);
    if (success) {
      (this.$refs.CompanyDetailsCard as CompanyDetailsCard).showEditAddressModal = false;
    }
  }

  public async deleteAddress(index: number) {
    await this.subcontractor.deleteAddress(index);
    (this.$refs.CompanyDetailsCard as CompanyDetailsCard).showRemoveAddressModal = false;
  }

  public async reload() {
    await this.subcontractor.loadData(this.$route.params.id);
  }

  private async mounted() {
    this.initialising = true;
    await this.subcontractor.loadData(this.$route.params.id);
    this.initialising = false;
  }
}
